import { deprecated } from "typesafe-actions";

import type { IContactInformation } from "@/shop/types/contacts";

import { ContactsActionType } from "./constants";

const { createStandardAction } = deprecated;

export const fetchContacts = createStandardAction(ContactsActionType.FETCH_CONTACTS)();

export const fetchContactsStart = createStandardAction(ContactsActionType.FETCH_CONTACTS_START)();

export const fetchContactsFail = createStandardAction(ContactsActionType.FETCH_CONTACTS_FAIL)();

export const fetchContactsSuccess = createStandardAction(ContactsActionType.FETCH_CONTACTS_SUCCESS).map(({ contacts }: { contacts: IContactInformation }) => ({
  payload: { contacts }
}));
